module.exports = __webpack_public_path__ + "static/media/podcastBadgeLevel3Locked.c86ed6e3.png";